import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExPhoneNumber({
  phone,
  expert_id,
  backupData,
  setBackupData,
}) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const [invalidPhone, setInvalidPhone] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (phone === "None") return;
    setPhoneNumber(phone);
  }, [phone]);

  const changePhone = (newValue) => {
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}change-phone`;
    const data = {
      expert_id,
      phone: newValue,
    };
    console.log(data);
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.phone_n = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  useEffect(() => {
    if (!/^[\d\s+]*$/.test(phoneNumber)) {
      setInvalidPhone(true);
    } else {
      setInvalidPhone(false);
    }
  }, [phoneNumber])

  return (
    <>
      <input
        placeholder="Phone number"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        onBlur={(e) => changePhone(e.target.value)}
        style={{color: invalidPhone ? "red" : "#365561"}}
        onMouseOver={() => invalidPhone && setShowTooltip(true)}
        onMouseOut={() => setShowTooltip(false)}
      />
      {invalidPhone && showTooltip && (
        <div className="absolute bg-gray-200 text-black p-2 rounded shadow-md mt-1" style={{zIndex: "1"}}>
          Only numbers and '+' are allowed.
        </div>
      )}
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "0" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
